module.exports = __webpack_public_path__ + "static/img/course_value.c39719aa.jpg";